function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = [
  'prefixCls',
  'className',
  'extraButton',
  'dataSource',
  'value',
  'renderItem',
  'onChange',
  'itemDisable',
];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _iterableToArray(iter) {
  if (
    (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) ||
    iter['@@iterator'] != null
  )
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useState, useEffect, useImperativeHandle } from 'react';
import { List } from 'udesk-ui';
import classNames from 'classnames';
import { usePrefixCls } from '../utils';
import ListHeader from './components/list-header';
import ListItem from './components/list-item';
import './style/index';
var ListCheckbox = function ListCheckbox(props, ref) {
  var customizePrefixCls = props.prefixCls,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$extraButton = props.extraButton,
    extraButton = _props$extraButton === void 0 ? [] : _props$extraButton,
    _props$dataSource = props.dataSource,
    dataSource = _props$dataSource === void 0 ? [] : _props$dataSource,
    value = props.value,
    _renderItem = props.renderItem,
    onChange = props.onChange,
    itemDisable = props.itemDisable,
    listRest = _objectWithoutProperties(props, _excluded);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    checkedList = _useState2[0],
    setCheckedList = _useState2[1];
  var _usePrefixCls = usePrefixCls('list-checkbox', customizePrefixCls || ''),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 1),
    listCheckboxPrefixCls = _usePrefixCls2[0];
  var classes = classNames(listCheckboxPrefixCls, className);
  useImperativeHandle(
    ref,
    function () {
      return {
        resetSelect: handleCancelSelect,
      };
    },
    [],
  );
  var handleCheckAllChange = function handleCheckAllChange(e) {
    var currCheckedList = _toConsumableArray(checkedList);
    if (e.target.checked) {
      var currCheckedIds = currCheckedList.map(function (el) {
        return el.id;
      });
      dataSource.forEach(function (el) {
        if (!currCheckedIds.includes(el.id)) {
          if (typeof itemDisable === 'function') {
            !(itemDisable === null || itemDisable === void 0 ? void 0 : itemDisable(el)) &&
              currCheckedList.push(_objectSpread({}, el));
          } else {
            currCheckedList.push(_objectSpread({}, el));
          }
        }
      });
    } else {
      var currCheckedListIds = dataSource.map(function (el) {
        return el.id;
      });
      currCheckedList = currCheckedList.filter(function (el) {
        if (!currCheckedListIds.includes(el.id)) {
          return el;
        }
        return false;
      });
    }
    setCheckedList(currCheckedList);
    onChange === null || onChange === void 0 ? void 0 : onChange(currCheckedList);
  };
  var handleSingleCheck = function handleSingleCheck(item) {
    var _currCheckedList;
    var currCheckedList = _toConsumableArray(checkedList);
    if (
      (_currCheckedList = currCheckedList) === null || _currCheckedList === void 0
        ? void 0
        : _currCheckedList.some(function (el) {
            return el.id === item.id;
          })
    ) {
      currCheckedList = currCheckedList.filter(function (el) {
        return el.id !== item.id;
      });
    } else {
      currCheckedList.push(_objectSpread({}, item));
    }
    setCheckedList(currCheckedList);
    onChange === null || onChange === void 0 ? void 0 : onChange(currCheckedList);
  };
  var handleCancelSelect = function handleCancelSelect() {
    setCheckedList([]);
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
  };
  useEffect(
    function () {
      if (Array.isArray(value) && value.length) {
        setCheckedList(value);
      }
    },
    [value],
  );
  return /*#__PURE__*/ React.createElement(
    List,
    _objectSpread(
      _objectSpread(
        {
          className: classes,
          dataSource: dataSource,
        },
        listRest,
      ),
      {},
      {
        header: /*#__PURE__*/ React.createElement(ListHeader, {
          extraButton: extraButton,
          dataSource: dataSource,
          checkedList: checkedList,
          handleCheckAllChange: handleCheckAllChange,
          handleCancelSelect: handleCancelSelect,
          itemDisable: itemDisable,
        }),
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/ React.createElement(
            ListItem,
            {
              item: item,
              checkedList: checkedList,
              handleSingleCheck: handleSingleCheck,
              itemDisable: itemDisable,
              key: item.key,
            },
            _renderItem === null || _renderItem === void 0 ? void 0 : _renderItem(item, index),
          );
        },
      },
    ),
  );
};
var FancyListCheckbox = /*#__PURE__*/ React.forwardRef(ListCheckbox);
export default FancyListCheckbox;
